import service from "@/services/types/otrosCargos";

export const namespaced = true;

export const state = () => ({
  list: [],
});

export const mutations = {
  LIST: (state, objs) => (state.list = objs),
};

export const actions = {
  list: ({ commit }, value) =>
    service.list(value).then((result) => {
      commit("LIST", result);

      return result;
    }),
};
